@if(mode==="edit" || mode==="add"){
<div class="ppl-mt20">
  <form nz-form nz-row [formGroup]="contactForm" class="ppl-p0">
    @if(isAttrAvailable('contactMethod')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactMethod">{{ getAttributes("contactMethod").label }}
          @if(getAttributes('contactMethod').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nzLabelAlign="left" nzTooltipPlacement="topRight">
          <!-- <nz-radio-group
            nz-tooltip
            nzTooltipTitle="{{ getAttributes('contactMethod').tooltip }}"
            nzTooltipPlacement="topRight"
            formControlName="contactMethod"
            class="ppl-radio-group"
            id="contactMethod"
          >
            @for(opt of communicationType; track $index){
            <label nz-radio-button [nzValue]="opt.lkpValueCode">{{
              opt.lkpValueName
            }}</label>
            }
          </nz-radio-group> -->
          <div [ngClass]="{'error': validationErrors['contactMethod'] }">
            <ppl-dropdown-select id="contactMethod" formControlName="contactMethod" [options]="communicationType"
            [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'" 
            [arialabel]="getAttributes('contactMethod').mandatory === 'Y' 
            ? getAttributes('contactMethod').label + ', required'  
            : getAttributes('contactMethod').label"
            [disabled]="mode === 'edit'" [attr.aria-invalid]="validationErrors['contactMethod'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['contactMethod'] ? 'contactMethod-error' : null"></ppl-dropdown-select>
          </div>
          @if (validationErrors['contactMethod']) {
          <span class="pl-1 error-message" id="contactMethod-error" role="alert">{{validationErrors['contactMethod']}}</span>
          }
        </nz-form-control>
      </nz-row> </nz-form-item>} @if(isAttrAvailable('value')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="value">{{ getAttributes("value").label }}
          @if(getAttributes('value').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control pl-2">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('fname')?.tooltip || ''" nzTooltipPlacement="topRight">
          <input nz-input
            formControlName="value" id="value" placeholder="{{ getAttributes('value').placeholder }}"
            [ngClass]="{'error': validationErrors['value'] }" (input)="limitDigits($event)" />
          </div>
          @if (validationErrors['value']) {
          <span class="pl-1 error-message">{{validationErrors['value']}}</span>
          }
          @if (phoneNUmberError) {
          <span class="pl-1 error-message">Please enter a valid 10 digit Phone number</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    } @if(isAttrAvailable('preferred')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="preferred" class="ppl-form-label">{{
          getAttributes("preferred").label }}</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <nz-switch class="ppl-switch" nzId="preferred" formControlName="preferred" pplNzAriaLabel
            [nzAriaLabel]="getAttributes('preferred').label" [attr.role]="'switch'"
            [attr.aria-checked]="contactForm.get('preferred')?.value ? 'true' : 'false'"></nz-switch>
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
  </form>
</div>
<div class="custom-row">

  <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
    (click)="cancelEdit()"></ppl-button>

  <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
    (click)="save()"></ppl-button>

</div>
} @else if(mode==="read"){
@if(canToggleFreeze || isHistoryRole || (leadStatus !== approvedStatus && !(entry === 'referral' && (leadStatus === 'Review Complete' || leadStatus === deniedStatus)) && !readOnly && !restrictReferralEdit)) {
<div class="custom-row">
@if(leadStatus !== approvedStatus && leadStatus !== deniedStatus && !(entry === 'referral' && leadStatus === 'Review Complete') && !readOnly && !restrictReferralEdit) {
  <ppl-button label="Add" icon="fa fa-plus" [customClass]="'ghost-button'" [iconPosition]="'left'" (click)="doMfaAdd()"
    [disabled]="changesBlocked" *authorize="[pageId, tabId, 'CommunicationMethods', 'section', 'edit']"></ppl-button>

  <!-- <span nz-icon nzType="plus-circle" nzTheme="outline" (click)="add()" *authorize="[pageId, tabId, 'CommunicationMethods', 'section', 'edit']"></span> -->
  }

  <!-- Freeze sits beside Add but is gated separately: Compliance must still be able to
       freeze/unfreeze an account whose lead status has been finalized. -->
  @if(canToggleFreeze) {
  <div class="ml-2">
    <ppl-button [ariaLabel]="freezeState.frozen ? 'Unfreeze changes' : 'Freeze changes'"
      [label]="freezeState.frozen ? 'Unfreeze' : 'Freeze'" [icon]="freezeState.frozen ? 'fa fa-unlock' : 'fa fa-lock'"
      [customClass]="'ghost-button'" [iconPosition]="'left'" (click)="toggleFreeze()"></ppl-button>
  </div>
  }

  @if(isHistoryRole) {
  <div class="ml-2">
    <ppl-button ariaLabel="Contact Details History" label="History" icon="fa fa-history"
      [customClass]="'ghost-button'" [iconPosition]="'left'" (click)="openContactHistory()"></ppl-button>
  </div>
  }
</div>
}

@if(copyOfGridData.length > 0){
@if(isMobileView){
<div class="card-layout pl-0 pr-0 no-margin">
  <div class="card" *ngFor="let data of copyOfGridData">
    <div class="card-item mt-2">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="12">Contact Method: </strong>
            <span nz-col nzSpan="12" [nzXs]="12">{{ data.contactMethod }}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>
    <div class="card-item">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="12">Email/Phone: </strong>
            <span nz-col nzSpan="12" [nzXs]="12">{{ data.value }}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>
    <div class="card-item">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="12">Is Preferred Method: </strong>
            <span nz-col nzSpan="12" [nzXs]="12">{{data.preferred}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>
    <div class="card-item ">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="12">Modified Date: </strong>
            <span nz-col nzSpan="12" [nzXs]="12">{{data.modifiedDate}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>
    <div class="btn-group mt-3 mb-2 d-flex justify-content-end">
      <div class="mr-2">
        <ppl-button ariaLabel="Edit" label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'"
          [iconPosition]="'left'" [disabled]="changesBlocked"
          (click)="action({data: data, action: 'edit'})"></ppl-button>
      </div>
      <ppl-button ariaLabel="Delete" label="Delete" icon="fa fa-trash" [customClass]="'ghost-button'"
        [iconPosition]="'left'" [disabled]="changesBlocked"
        (click)="action({data: data, action: 'delete'})"></ppl-button>
    </div>
  </div>
</div>
} @else {
<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="isSectionEditable" [data]="copyOfGridData"
  [disableSelection]="true" [cols]="cols" (gridAction)="action($event)" [gridTitle]="false" [pagination]="false"
  [loadPage]="true" [actionButtons]="actionButtons">
</ppl-list-table>
}
}@else {
<nz-row>
  <p tabindex="0">No Data found</p>
</nz-row>
}



}@else if (mode==="read" && !copyOfGridData) {
<nz-row>
  <p tabindex="0">No Data found</p>
</nz-row>
}

@if(!isMobileView) {
<div class="custom-row" style="height: 0.3rem"></div>
}

<div class="filter-panel">
  <ng-template #loginWarningDialog>
    <p>Please note that logins associated with the old information will be deactivated.</p>
  </ng-template>
  <ng-template #deleteWarningDialog>
    <p>Please note that the logins associated with this contact method will be deactivated.</p>
  </ng-template>
  <ng-template #contactHistoryDialog let-cancel="cancel">
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false"
      [data]="contactHistoryData" [disableSelection]="true" [cols]="contactHistoryCols"
      [gridTitle]="false" [pagination]="false">
    </ppl-list-table>
  </ng-template>
  <ng-template #freezeConfirmDialog>
    @if(freezeState.frozen){
    <p>
      Unfreezing will allow PPL staff to edit and delete this account's Contact Details again.
      Are you sure?
    </p>
    } @else {
    <p>
      Freezing will stop PPL staff from editing or deleting this account's Contact Details.
      You and the account holder can still make changes. This does not affect the Payment
      Method Form. Are you sure?
    </p>
    }
  </ng-template>
</div>